<template>
    <div>
        <div class="row cursor-pointer" @click.prevent="readMessage(message)"
             style="line-height: 1.9; margin: 5px 0px 0px 0px; border: 1px solid lightgrey; padding: 10px; background-color: #EFEFEF;">
            <div class="col-xs-8 col-sm-9 col-md-10">
                <span :style="{fontWeight:fontWeight(message)}">
                    <slot name="message-header"></slot>
                    <span v-html="message.emailSubjectLine"></span> -
                    <span>{{message.sendDate | shortDate}}</span>
                </span>
            </div>
            <div class="col-xs-4 col-sm-3 col-md-2">
                <div class="pull-right">
                    <ac-button class="btn btn-xs btn-red" title="Delete" style="margin-left: 10px;"
                               :action="()=>{deleteMessage(message)}">
                        <i class="fa fa-trash-o" style="display: inline-block;"></i>
                    </ac-button>
                </div>
            </div>
        </div>
        <div style="border-color: lightgrey; border-style: solid; border-width: 0px 1px 1px 1px; padding: 10px;"
             v-show="selectedMessageId===message.messageId">
            <span v-html="message.emailBody"></span>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: "Message",
        props: {message: {type: [Object], required: true}, storeModule: {type: [String], required: false, default: ''}},
        computed: {
            ...mapGetters(['selectedMessageId']),
            modulePrefix() {
                return this.storeModule.length == 0 ? '' : `${this.storeModule}/`
            }
        },
        methods: {
            fontWeight(message) {
                return message.isRead ? 400 : 600;
            },
            readMessage(message) {
                if (!message.isRead) {
                    this.$store.dispatch(`${this.modulePrefix}MARK_AS_READ`, {...message});
                } else {
                    if (this.selectedMessageId == message.messageId) {
                        this.$store.dispatch("SET_SELECTED_MESSAGE_ID", null, {root: true});
                    } else {
                        this.$store.dispatch("SET_SELECTED_MESSAGE_ID", message.messageId, {root: true});
                    }
                }
            },
            deleteMessage(message) {
                this.$store.dispatch(`${this.modulePrefix}DELETE_MESSAGE`, {...message});
            }
        }
    }
</script>

<style scoped>

</style>